import React from 'react';

import { RealisedIncome } from '@ndvr/reporting-api';

import { Card } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';

import { WholeDollars } from '../../reporting/HeroStatCard';
import { MV_CELL, TABLE_CARD_HEADER_CLASS, TABLE_CLASS } from '../../reporting/table-styles';

const AmountCell = ({ value }: { value: string }) => (
    <TableCell className={MV_CELL}>
        <WholeDollars value={value} />
    </TableCell>
);

// Income received over the 12 months up to the report date, by kind. A header-less table so its
// rows share the row height and rules of the projected income table below it.
export const TrailingIncomeCard = ({ income }: { income: RealisedIncome }) => (
    <Card className="border-border overflow-hidden rounded-2xl border bg-white">
        <div className={TABLE_CARD_HEADER_CLASS}>
            <h3 className="font-heading text-cocoa-1000 text-xl">Trailing 12 months</h3>
        </div>
        <Table className={TABLE_CLASS}>
            <TableBody>
                <TableRow>
                    <TableCell className="text-cocoa-900 text-sm">Dividends</TableCell>
                    <AmountCell value={income.dividendIncome} />
                </TableRow>
                <TableRow>
                    <TableCell className="text-cocoa-900 text-sm">Interest</TableCell>
                    <AmountCell value={income.interestIncome} />
                </TableRow>
                <TableRow className="bg-cocoa-100/40 hover:bg-cocoa-100/40">
                    <TableCell className="text-cocoa-1000 text-sm font-semibold">Total income</TableCell>
                    <AmountCell value={income.totalIncome} />
                </TableRow>
            </TableBody>
        </Table>
    </Card>
);
